"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MachineDetail = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const MachineDetail_1 = require("../../sections/machine-detail/MachineDetail");
const react_router_dom_1 = require("react-router-dom");
const MachineDetail = ({ title }) => {
    const { id } = (0, react_router_dom_1.useParams)();
    return (0, jsx_runtime_1.jsx)(MachineDetail_1.MachineDetail, { title: title, id: id });
};
exports.MachineDetail = MachineDetail;
